// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating Layers Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing Layers Worker')

  // $FlowFixMe
  const AssetWorker = require('worker-loader?name=[hash].layers.wrkr.js!./worker.js')
  worker = new AssetWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
